export const LINKS = {
  general: {
    twitter: 'https://twitter.com/edumorph',
    instagram: 'https://instagram.com/edumorph',
    linkedin: 'https://linkedin.com/company/edumorph',
  },
  apps: {
    ainstein: {
      social: {
        twitter: 'https://twitter.com/pankaj6apr',
        instagram: 'https://instagram.com/appainstein',
      },
      appStores: {
        ios: 'https://apps.apple.com/us/app/ainstein-ai-lessons-quizzes/id6746379171',
        android: '#',
      }
    },
    roamr: {
      social: {
        twitter: 'https://twitter.com/pankaj6apr',
        instagram: 'https://instagram.com/approamr',
      },
      appStores: {
        ios: 'https://apps.apple.com/in/app/trip-planner-roamr/id6742901057',
        android: 'https://play.google.com/store/apps/details?id=com.pankaj6apr.roamr',
      }
    },
    eunoia: {
      social: {
        twitter: 'https://twitter.com/pankaj6apr',
        instagram: 'https://instagram.com/appeunoia',
      },
      appStores: {
        ios: 'https://apps.apple.com/in/app/self-care-journal-eunoia/id6745425428',
        android: 'https://play.google.com/store/apps/details?id=com.pankaj6apr.journAI',
      }
    }
  }
};